import { Card, Flex, Text } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import CustomRichTextEditor from '../../../../components/rich-text-editor/CustomRichTextEditor.tsx'
import { IProductAdd } from '../../../../interfaces/business/seller/IProductCreate.ts'

type AddProductProps = {
	form: UseFormReturnType<IProductAdd, (values: IProductAdd) => IProductAdd>
}
const AddProductDescription = ({ form }: AddProductProps) => {
	return (
		<Card>
			<Flex direction='column' gap='sm'>
				<Text fw={600}>Product Details</Text>
				{/* <Textarea
					rows={6}
					label='Product Description'
					placeholder='Description'
					{...form.getInputProps('description')}
				/>
				<Textarea
					rows={6}
					label='Product Highlights'
					placeholder='Highlights'
					{...form.getInputProps('highlight')}
				/> */}
				<Flex direction='column' gap='sm'>
					<Text fw={600}>Product Description</Text>
					{/* <Textarea
					rows={6}
					label='Product Description'
					classNames={{ input: classes.input }}
					placeholder='Description'
					{...form.getInputProps('description')}
				/> */}
					<CustomRichTextEditor
						value={form.values.description}
						onChange={(e) => {
							// setProductDescription
							form.setValues({ ...form, description: e })
						}}
					/>
					<Text fw={600}>Product Highlights</Text>

					<CustomRichTextEditor
						value={form.values.highlight}
						onChange={(e) => {
							form.setValues({ ...form, highlight: e })
						}}
					/>
					{/* <Textarea
					rows={6}
					label='Product Highlights'
					classNames={{ input: classes.input }}
					placeholder='Highlights'
					{...form.getInputProps('highlight')}
				/> */}
				</Flex>
			</Flex>
		</Card>
	)
}

export default AddProductDescription
